import React from 'react'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import AdSensePlaceholder from './AdSensePlaceholder'
import AdSenseBanner from './AdSenseBanner'

interface AdSenseWrapperProps {
    type?: 'placeholder' | 'banner'
    variant?: 'banner' | 'rectangle' | 'square' | 'skyscraper' | 'leaderboard' | 'large-banner' | 'medium-banner' | 'mobile-banner'
    position?: 'top' | 'side' | 'bottom' | 'header' | 'footer' | 'content' | 'sidebar'
    responsive?: boolean
    sticky?: boolean
    maxWidth?: number
}

const AdSenseWrapper: React.FC<AdSenseWrapperProps> = ({
    type = 'placeholder',
    variant = 'banner',
    position = 'content',
    responsive = true,
    sticky = false,
    maxWidth
}) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    // Don't show sidebar ads on mobile
    if (isMobile && (position === 'side' || position === 'sidebar')) {
        return null
    }

    const containerProps = {
        sx: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            ...(maxWidth && { maxWidth }),
            ...(sticky && {
                position: 'sticky',
                top: 100,
                zIndex: 1
            })
        }
    }

    if (type === 'banner') {
        return (
            <Box {...containerProps}>
                <AdSenseBanner
                    variant={variant as any}
                    position={position as any}
                    responsive={responsive}
                />
            </Box>
        )
    }

    return (
        <Box {...containerProps}>
            <AdSensePlaceholder
                variant={variant as any}
                position={position as any}
            />
        </Box>
    )
}

export default AdSenseWrapper
